import React from 'react';
import ProductFitQuiz from './ProductFitQuiz';

/**
 * A full-page component that embeds the Product Fit Quiz.
 * It provides a clean, centered layout for the quiz.
 */
const ProductFitQuizFullPage: React.FC = () => {
  return (
    <div className="h-screen flex items-center justify-center">
      <div className="w-full max-w-2xl h-[100vh] shadow-2xl ring-1 ring-blue-200/50 overflow-hidden rounded-2xl">
        <ProductFitQuiz mode="embedded" />
      </div>
    </div>
  );
};

export default ProductFitQuizFullPage;
